import React, { useEffect, useMemo, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, FormHelperText, Autocomplete, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { clothStockReg } from '../TitleList';
import styled, { inputImages, inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { errorStyles } from '../../Utils/table';
import Dropdown from '../FieldsComponents/Dropdown';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import { selectlocationdata } from '../Selectors/Master/ItemSelectors';
import axios from 'axios';
import PreviewIcon from '@mui/icons-material/Preview';
import { insertTransferClothstk } from '../../Store/PHPSlice/UploadStk/TransferCloth';


const TransferClothEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [formData, setFormData] = useState({
        dt: '',
        baleId: '',
        clothId: '',
        lumpId: '',
        locfrom: '',
        locto: '',
        userId: userdata?.ID
    });
    const [clothlist, setClothlist] = useState([]);
    const [balelist, setBalelist] = useState([]);
    const [lumplist, setLumplist] = useState([]);
    const [finalData, setFinalData] = useState([]);
    const [selectedIndexes, setSelectedIndexes] = useState([]);
    const [lumpView, setLumpView] = useState({});


    const dispatch = useDispatch();
    const locdata = useSelector(selectlocationdata);


    useEffect(() => {
        dispatch(fetchLocationData());
    }, [dispatch]);

    const [errors, setErrors] = useState({});
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        switch (dropdownType) {
            case 'locfrom':
                if (value) {
                    fetchLocationWiseClothstk(value);
                } else {
                    setClothlist([]);
                    setBalelist([]);
                    setLumplist([]);
                }
                break;
            case 'clothId':
                if (value) {
                    fetchBalefromClothstk(value);
                } else {
                    setLumplist([]);
                    setBalelist([]);
                }
                break;
            case 'baleId':
                if (value) {
                    const data = {
                        baleId: value,
                        locId: formData.locfrom
                    };
                    fetchLumpfromBalestk(data);
                } else {
                    setLumplist([]);
                }
            default:
                break;
        };
    };

    const dropdownlistfirst = [
        {
            label: 'Location From',
            id: 'locfrom',
            options: locdata?.data || [],
            value: formData.locfrom,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locfrom', value: newValue ? newValue.ID : '' } }, 'locfrom'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'To',
            id: 'locto',
            options: locdata?.data?.filter((item) => item.ID !== formData.locfrom) || [],
            value: formData.locto,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locto', value: newValue ? newValue.ID : '' } }, 'locto'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Cloth',
            id: 'clothId',
            options: clothlist || [],
            value: formData.clothId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'clothId', value: newValue ? newValue.ID : '' } }, 'clothId'),
            getOptionLabel: (option) => option.clothNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Bale No.',
            id: 'baleId',
            options: balelist || [],
            value: formData.baleId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'baleId', value: newValue ? newValue.ID : '' } }, 'baleId'),
            getOptionLabel: (option) => option.bale || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            }
        },
        // {
        //     label: 'Lumps',
        //     id: 'lumpId',
        //     options: lumplist || [],
        //     value: formData.lumpId,
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'lumpId', value: newValue ? newValue.ID : '' } }, 'lumpId'),
        //     getOptionLabel: (option) => option.lumpNo || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     }
        // },
    ];

    const isDesktop = useMediaQuery('(min-width:768px)');

    const fetchLocationWiseClothstk = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getLocationWiseClothlist_stk&locId=${id}`);
            // console.log(response.data);
            setClothlist(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };


    const fetchBalefromClothstk = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getBaleFromClothstk&clothId=${id}`);
            // console.log(response.data);
            setBalelist(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };


    const fetchLumpfromBalestk = async (id) => {
        const { baleId, locId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getLumpsFrombalestk&baleId=${baleId}&locId=${locId}`);
            // console.log(response.data);
            setLumplist(response?.data?.data);
        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const handleCheckboxChange = (index) => {
        const updatedList = [...lumplist];
        updatedList[index].checked = !updatedList[index].checked;
        setLumplist(updatedList);
    };


    const handleBaleChange = (index, value) => {
        setLumplist(prevData =>
            prevData.map((item, i) =>
                i === index ? { ...item, baleNo: value } : item
            )
        );
    };

    const handleCheckboxChangeByIndex = (index) => {
        setSelectedIndexes(prev => {
            if (prev.includes(index)) {
                return prev.filter(i => i !== index); // Uncheck
            } else {
                return [...prev, index]; // Check
            }
        });
    };

    const handleRemoveSelectedByIndex = () => {
        const newData = finalData.filter((_, idx) => !selectedIndexes.includes(idx));
        setFinalData(newData);
        setSelectedIndexes([]);
    };

    const handleLumpView = (data) => {
        setLumpView(data);
        console.log(data);
    };

    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    const handleAddMultiCloth = () => {
        const lumparr = lumplist?.filter((item) => item.checked === true);
        if (formData?.clothId === "") {
            alert("Select Cloth");
        } else if (formData?.baleId === "") {
            alert("Select Bale");
        } else if (lumparr?.length === 0) {
            alert("Select Lump");
        } else {
            const clothnm = clothlist?.find((item) => item.ID === formData.clothId)?.clothNm;
            const balenm = balelist?.find((item) => item.ID === formData.baleId)?.bale;

            const totmtr = lumparr?.reduce((acc, sum) => acc + parseFloat(sum.bmtr) || 0, 0);
            const datas = {
                clothId: formData.clothId,
                clothNm: clothnm,
                baleId: formData.baleId,
                baleNm: balenm,
                lumps: lumparr,
                totmtr: totmtr
            };
            const updatedBaleList = balelist?.filter((item) => !finalData?.some((fd) => fd.baleId === item.ID));
            // console.log(updatedBaleList,'updatedBaleList');
            const updateBale = updatedBaleList?.filter((item) => item.ID !== datas?.baleId);
            // console.log(updateBale?.length,'updateBale');

            const updatedClothlist = clothlist?.filter((item) => !finalData?.some((fd) => fd.clothId === item.ID));
            const updatedCloth = updatedClothlist?.filter((item) => item.ID !== datas?.clothId);


            setFinalData(prev => [...prev, datas]);
            setLumplist([]);
            if (updateBale?.length === 0) {
                setClothlist(updatedCloth);
            }
            setBalelist(updateBale);
        }

    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.dt.trim() === '') {
            alert('Select Date');
        } else if (formData.locfrom.trim() === "") {
            alert('Select Location From');
        } else if (formData.locto.trim() === "") {
            alert("Select Location To");
        } else {
            const postdata = {
                dt: formData.dt,
                userId: formData.userId,
                locfrom: formData.locfrom,
                locto: formData.locto,
                finalData: finalData
            }
            // console.log(postdata);

            dispatch(insertTransferClothstk(postdata))
                .unwrap()
                .then((result) => {
                    // Handle success
                    console.log('POST request successful!', result);
                    // toast.success("Cloth Stock Added");
                    alert("Transfer Cloth Successful");
                    window.location.reload();
                    // You may want to update your component state or perform any other action
                })
                .catch((error) => {
                    // Handle error
                    console.error('Error while making POST request:', error);
                    // You may want to display an error message to the user or perform any other action
                });
        }

    };


    return (
        <>
            <Titlebar data={clothStockReg} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Transfer Cloth Stock Entry</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='dt' >Date:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    id='dt'
                                                    name='dt'
                                                    type='date'
                                                    value={formData.dt}
                                                    onChange={handleDateChange}
                                                    inputProps={{ style: styled.inputDate }}
                                                    sx={inputStyles}
                                                />
                                                {errors.dt && <FormHelperText style={errorStyles}>{errors.dt}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }
                                <Grid item xs={6} textAlign="center"></Grid>


                                <Grid item xs={6} textAlign="center" marginTop={2}>
                                    <h3>Lump Details</h3>
                                </Grid>


                                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                    <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                                        <TableBody>

                                            <TableRow>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Select</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Lump Barcode</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>color</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Loose</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Mtr</TableCell>
                                            </TableRow>

                                        </TableBody>

                                        {
                                            lumplist?.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                        <input
                                                            type="checkbox"
                                                            checked={item.checked}
                                                            onChange={() => handleCheckboxChange(index)}
                                                        />

                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.barcd}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.color}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.loose === "1" ? "Yes" : "No"}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                        <input
                                                            type="text"
                                                            value={item.bmtr}  // Ensure value is either the number or an empty string
                                                            name="bmtr"
                                                            style={{ width: '100px', padding: '1px' }}
                                                            // onChange={(e) => handleBaleChange(index, e.target.value)}
                                                            readOnly
                                                        />
                                                    </TableCell>

                                                </TableRow>
                                            ))
                                        }
                                    </Table>
                                </TableContainer>


                                <Grid item xs={6} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleAddMultiCloth} disabled={lumplist?.length === 0}>Add</Button>
                                </Grid>
                                <Grid item xs={6} textAlign="center"></Grid>


                                <Grid item xs={6} textAlign="center" marginTop={2}>
                                    <h3>Multiple Cloths</h3>
                                </Grid>


                                <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                    <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                                        <TableBody>

                                            <TableRow>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Select</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Cloth</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Bale</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Lump</TableCell>
                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>totmtr</TableCell>
                                            </TableRow>

                                        </TableBody>

                                        {
                                            finalData?.map((item, index) => (
                                                <TableRow key={index}>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedIndexes.includes(index)}
                                                            onChange={() => handleCheckboxChangeByIndex(index)}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.clothNm}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{item.baleNm}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                        <PreviewIcon onClick={() => handleLumpView(item)} className='cursor-pointer' />
                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                        {item.totmtr}
                                                    </TableCell>

                                                </TableRow>
                                            ))
                                        }
                                    </Table>
                                </TableContainer>


                                {


                                    <div style={{ width: '70%', border: '1px solid black', textAlign: 'center', padding: '1%', borderRadius: '10px' }} >
                                        <button type='button' onClick={() => setLumpView([])} style={{ marginLeft: '70%', fontSize: '1rem', background: '#1670de', color: 'white' }}>x</button>
                                        <h4>Bale - {lumpView.baleNo}</h4>

                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Lump Barcode</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>color</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Loose</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' className='tbl-row'>Mtr</TableCell>
                                                    </TableRow>

                                                </TableBody>

                                                {lumpView?.lumps?.map((val, vindex) => (
                                                    <TableRow key={vindex}>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{vindex + 1}</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{val.barcd}</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{val.color}</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' >{val.loose === "1" ? "Yes" : "No"}</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                            <input
                                                                type="text"
                                                                value={val.bmtr}  // Ensure value is either the number or an empty string
                                                                name="bmtr"
                                                                style={{ width: '100px', padding: '1px' }}
                                                                // onChange={(e) => handleBaleChange(index, e.target.value)}
                                                                readOnly
                                                            />
                                                        </TableCell>

                                                    </TableRow>
                                                ))
                                                }
                                            </Table>
                                        </TableContainer>
                                    </div>

                                }



                                <Grid item xs={12} textAlign="center" style={{ display: 'flex', justifyContent: 'space-around' }}>
                                    <Button variant="contained" color="primary" disabled={finalData?.length === 0} onClick={handleSubmit}>Submit</Button>
                                    <Button variant="contained" color="primary" size='small' onClick={handleRemoveSelectedByIndex} disabled={selectedIndexes?.length === 0}>Remove</Button>
                                </Grid>
                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default TransferClothEntry;
